export default __webpack_public_path__ + "7bb8a20166aba2d07e656aa9d9ada0f5.png";